import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SystemConfigurationSelectors, SystemConfigurationActions, Authentication, RESTService, ConnectivitySelectors } from '@spm/core';
import PropTypes from 'prop-types';
import Idle from 'react-idle';
import SessionTimeoutDialogComponent from './SessionTimeoutDialogComponent';
import ErrorBoundary from '../ErrorHandling/ErrorBoundaryComponent';
import PATHS from '../router/Paths';
/**
 * The SessionTimeoutContainer initiates the rendering of the SessionTimeoutMonitorComponent.
 * The SessionTimeoutMonitorComponent displays the modal dialog when the user is
 * idle. If the user is logged in the session timout is active.
 */

export var SessionTimeoutContainer = /*#__PURE__*/function (_Component) {
  _inherits(SessionTimeoutContainer, _Component);

  var _super = _createSuper(SessionTimeoutContainer);
  /**
   * Creates an instance of SessionTimeoutContainer.
   * @param {*} props
   * @memberof SessionTimeoutContainer
   */


  function SessionTimeoutContainer(props) {
    var _this;

    _classCallCheck(this, SessionTimeoutContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          loadSystemConfiguration = _this$props.loadSystemConfiguration,
          isFetchingSystemConfiguration = _this$props.isFetchingSystemConfiguration; // TODO: Loading system configuration here seems redundant. User
      // is never logged in when mounted - err on side of caution and
      // leave for now but consider removing December release -- // BOS

      _this.loadSystemConfigForLoggedInUser(loadSystemConfiguration);

      if (!isFetchingSystemConfiguration) {
        _this.startTimer();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.sessionTimer);

      _this.setState({
        systemConfigLoaded: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatusChange", function (_ref) {
      var isUserIdle = _ref.idle;

      _this.setState(function (prevState) {
        return {
          totalIdleTime: isUserIdle ? prevState.totalIdleTime : 0,
          isUserIdle: isUserIdle
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStaySignedIn", function () {
      _this.pingServer();

      _this.closeSessionTimeoutDialog();
    });

    _defineProperty(_assertThisInitialized(_this), "closeSessionTimeoutDialog", function () {
      _this.setState({
        isDialogVisible: false
      });

      window.govhhswds.dialog.close(document);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSignOutAndRedirectToLogin", function (countdownTimerEnd) {
      _this.closeSessionTimeoutDialog();

      _this.logout(function () {
        _this.setState({
          systemConfigLoaded: false
        });

        _this.redirectToLoginPage(countdownTimerEnd);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "logout", function (callback) {
      Authentication.logout(callback, false);
    });

    _defineProperty(_assertThisInitialized(_this), "redirectToLoginPage", function (countdownTimerEnd) {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          location = _this$props2.location;

      if (location && location.pathname !== PATHS.HOME) {
        var _context;

        var timeoutUrl = _concatInstanceProperty(_context = "").call(_context, process.env.REACT_APP_SESSION_TIMEOUT_REDIRECT_URL || '/login');

        var pathname = countdownTimerEnd ? timeoutUrl : PATHS.HOME;
        history.push({
          pathname: pathname,
          state: {
            sessionCountdownTimerEnd: countdownTimerEnd
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkUserTotalIdleTime", function () {
      var isUserIdle = _this.state.isUserIdle;

      if (_this.userLoggedIn() && isUserIdle) {
        _this.recalculateUserIdleTime();
      } else {
        _this.pingServer();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadSystemConfigForLoggedInUser", function (loadSystemConfiguration) {
      if (_this.userLoggedIn() && !_this.state.systemConfigLoaded) {
        loadSystemConfiguration();

        _this.setState({
          systemConfigLoaded: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "userLoggedIn", function () {
      return Authentication.userTypeIs([Authentication.USER_TYPES.STANDARD, Authentication.USER_TYPES.LINKED, Authentication.USER_TYPES.GENERATED]);
    });

    _defineProperty(_assertThisInitialized(_this), "recalculateUserIdleTime", function () {
      var isUserIdleTimeExceeded = _this.userIdleTimeExceeded();

      _this.setState({
        isDialogVisible: isUserIdleTimeExceeded
      });
    });

    _defineProperty(_assertThisInitialized(_this), "userIdleTimeExceeded", function () {
      var _this$props3 = _this.props,
          sessionInactivityPingInterval = _this$props3.sessionInactivityPingInterval,
          inactivityDialogCount = _this$props3.inactivityDialogCount;
      var sessionTimeoutPeriod = _this.props.sessionTimeoutPeriod; // buffering period to allow for length of time for ping interval check of 60 seconds
      // plus an arbitrary latency lag (converted to milliseconds).

      var bufferingPeriod = 70 * 1000; // adjusting for the time it is going to take for modal dialog to appear
      // dialog count is in seconds so multiplying by 1000

      sessionTimeoutPeriod -= inactivityDialogCount * 1000;
      var isDialogVisibleUpdated = null;

      _this.setState(function (prevState) {
        var totalIdleTime = prevState.totalIdleTime + sessionInactivityPingInterval;
        isDialogVisibleUpdated = prevState.isDialogVisible || totalIdleTime >= sessionTimeoutPeriod - bufferingPeriod;
        return {
          totalIdleTime: totalIdleTime
        };
      });

      return isDialogVisibleUpdated;
    });

    _defineProperty(_assertThisInitialized(_this), "pingServer", function () {
      if (_this.props.isOnline) {
        var _context2;

        var url = _concatInstanceProperty(_context2 = "").call(_context2, process.env.REACT_APP_REST_URL, "/v1/ua/system_configurations");

        RESTService.get(url, _this.pingServerCallback);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pingServerCallback", function (success, response) {
      // Ignore a successful response, we are just keeping the server alive.
      // However for an unsuccessful response we want to throw the error and let // the error boundary handle it. Particularly if a LTPA cookie expires
      // a 401 will be returned and the ErrorBoundary will redirect to the logon // page
      if (!success) {
        if (response instanceof Error) {
          _this.setState({
            pingServerError: response
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "startTimer", function () {
      var sessionInactivityPingInterval = _this.props.sessionInactivityPingInterval;
      _this.sessionTimer = window.setInterval(_this.checkUserTotalIdleTime, sessionInactivityPingInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props4 = _this.props,
          isSessionTimoutEnabled = _this$props4.isSessionTimoutEnabled,
          sessionInactivityPingInterval = _this$props4.sessionInactivityPingInterval,
          inactivityDialogCount = _this$props4.inactivityDialogCount;

      var isUserLoggedIn = _this.userLoggedIn();

      return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(React.Fragment, null, isSessionTimoutEnabled && isUserLoggedIn && /*#__PURE__*/React.createElement(Idle, {
        key: "idle",
        onChange: _this.handleStatusChange,
        timeout: sessionInactivityPingInterval
      }), isSessionTimoutEnabled && isUserLoggedIn && _this.state.isDialogVisible && /*#__PURE__*/React.createElement(SessionTimeoutDialogComponent, {
        key: "idle-dialog",
        inactivityDialogCount: inactivityDialogCount,
        onSignOutAndRedirectToLogin: _this.handleSignOutAndRedirectToLogin,
        onStaySignedIn: _this.handleStaySignedIn
      })));
    });

    _this.state = {
      totalIdleTime: 0,
      isDialogVisible: false,
      isUserIdle: false,
      pingServerError: null,
      systemConfigLoaded: false
    };
    return _this;
  }

  _createClass(SessionTimeoutContainer, [{
    key: "componentDidUpdate",

    /**
     * On update check if error from server ping. If there is one
     * then throw it.
     */
    value: function componentDidUpdate() {
      if (this.state.pingServerError !== null) {
        throw this.state.pingServerError;
      }

      if (this.props.isOnline) {
        this.loadSystemConfigForLoggedInUser(this.props.loadSystemConfiguration);
      }
    }
  }]);

  return SessionTimeoutContainer;
}(Component);
SessionTimeoutContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  history: PropTypes.object.isRequired,
  inactivityDialogCount: PropTypes.number,
  isFetchingSystemConfiguration: PropTypes.bool.isRequired,
  isOnline: PropTypes.bool.isRequired,
  isSessionTimoutEnabled: PropTypes.bool.isRequired,
  loadSystemConfiguration: PropTypes.func.isRequired,
  sessionInactivityPingInterval: PropTypes.number,
  sessionTimeoutPeriod: PropTypes.number
} : {};
SessionTimeoutContainer.defaultProps = {
  inactivityDialogCount: 120,
  sessionInactivityPingInterval: process.env.REACT_APP_SESSION_PING_INTERVAL ? process.env.REACT_APP_SESSION_PING_INTERVAL * 1000 : 60000,
  sessionTimeoutPeriod: process.env.REACT_APP_SESSION_INACTIVITY_TIMEOUT ? process.env.REACT_APP_SESSION_INACTIVITY_TIMEOUT * 1000 : 60000 * 30
};
/**
 * Used to subscribe to Redux store updates. This will be called any time the store is updated. Will
 * be merged into the component props.
 *
 * @param {*} state the store state
 */

export var mapStateToProps = function mapStateToProps(state) {
  return {
    isSessionTimoutEnabled: SystemConfigurationSelectors.getBooleanValue(state, 'curam.environment.enable.timeout.warning.modal'),
    inactivityDialogCount: SystemConfigurationSelectors.getIntegerValue(state, 'curam.environment.timeout.warning.modal.time'),
    isFetchingSystemConfiguration: SystemConfigurationSelectors.isFetchingSystemConfiguration(state),
    systemConfigurationError: SystemConfigurationSelectors.systemConfigurationError(state),
    isOnline: ConnectivitySelectors.getOnline(state)
  };
};
/**
 * Redux action creators that will be merged into the component props.
 *
 * @export
 * @param {any} dispatch the dispatch function
 * @returns the action creators
 */

export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadSystemConfiguration: function loadSystemConfiguration() {
      SystemConfigurationActions.getSystemPropertiesAction(dispatch);
    }
  };
};
/**
 * Manages the time out for a user's session. If a user is inactive for a certain period of
 * time then a dialog will be displayed to them notifying them that their session is about to timeout.
 * If they do not take action within the time shown, they will be logged out and returned to the
 * login page.
 */

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SessionTimeoutContainer));